module.exports = __webpack_public_path__ + "img/app_download.8a101058.png";